import React, { useState, useEffect } from 'react'

// react redux
import { connect } from 'react-redux'

// react bootstrap
import { Container } from 'react-bootstrap'

// styles
import "./styles/abandonedCart-styles.scss"

// includes
import AbandonedCartTableTopBar from './includes/AbandonedCartTable/AbandonedCartTableTopBar'
import AbandonedCartTable from './includes/AbandonedCartTable/AbandonedCartTable'

// common components
import Pagination from 'components/CommonComponents/Pagination'

// helpers
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions'

// app messages
import {
    CONFIRMATION_BEFORE_DELETING_BRAND,
    ERROR_WHILE_FETCHING_BRANDS,
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED
} from 'utlis/AppMessages/AppMessages'

// APIs
import { getOrders } from 'utlis/Apis/AbandonedCart_API'

// toast
import { toast } from 'react-toastify'

// custom hook
import useQueryHook from 'utlis/CustomHooks/useQueryHook'


function AbandonedCart(props) {
    // props
    const { commonToken } = props

    // states
    const loadingCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    const [abandonedCart, setAbandonedCart] = useState([])
    const [loading, setLoading] = useState(false)
    const [allCheckboxSelected, setAllCheckboxesSelected] = useState(false)
    const [column__userEmail, setColumn__userEmail] = useState(true)
    const [column__orderDate, setColumn__orderDate] = useState(true)
    const [column__cartItems, setColumn__cartItems] = useState(true)
    const [column__total, setColumn__total] = useState(true)
    const [paginationLinks, setPaginationLinks] = useState([])


    const [searchQuery, setSearchQuery] = useState("")

    const [orderStatusList, setOrderStatusList] = useState([])

    let queryy = useQueryHook();

    useEffect(() => {
        let page = queryy.get('page')
        let keyword = queryy.get('keyword')

        let query = `${(keyword) ? "keyword=" + keyword + "&" : ""}${page ? "page=" + page : ""}`
        setLoading(true)

        // getting orders
        getOrders(props.currentUser.userToken).then(res => {
            setLoading(false)
            const resData = res.data
            console.log("resData ", resData);

            // scroll the page to the top
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setPaginationLinks(resData.links)
                setAbandonedCart(resData.data)
            }
            if (resData && resData.error) {
                console.log(ERROR_WHILE_FETCHING_BRANDS, resData)
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_BRANDS, {
                    autoClose: 3000,
                    onClose: () => {
                        // disabling loading
                        setLoading(false)
                    }
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} get abandonedCart `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setLoading(false)
                }
            })
        })
    }, [props])

    const handleSelectAllChange = (ev) => {
        const checkboxes = document.getElementsByClassName('all-checkboxes-selector-checkbox')
        setAllCheckboxesSelected(!allCheckboxSelected)
        setTimeout(() => {
            if (ev.target.checked) {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = true
                });
            } else {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = false
                });
            }
        }, 50);

    };

    // deleting
    const handleDelete = (ev) => {
        ev.preventDefault()
        var confirmation = window.confirm(CONFIRMATION_BEFORE_DELETING_BRAND)

        if (confirmation) {
        }
    }
    const handleSearchChange = debounce(ev => {
        let searchQueryValue = ev.target.value
        if (searchQueryValue && searchQueryValue.length) {
            setSearchQuery(searchQueryValue)
            props.history.push(`/my-sales/abandoned-carts?keyword=${searchQueryValue}&page=1`)
        }

        if (!searchQueryValue) {
            setSearchQuery("")
            props.history.push(`/my-sales/abandoned-carts?page=1`)
        }
    }, 500)

    return (
        <section id="app-abandonedCart" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-abandonedCart">
                    <div className="app-header-wrapper d-flex mb-2">
                        <p className="app-heading text-capitalize">Abandoned Carts</p>
                    </div>
                    <div className="app-content-container">
                        <div className="app-card">
                            <div className="app-card-content bg-white border st-border-light st-default-rounded-block mb-3">
                                <div className="acc_top-bar border-bottom st-border-light">
                                    <AbandonedCartTableTopBar
                                        column__userEmail={column__userEmail}
                                        column__orderDate={column__orderDate}
                                        column__cartItems={column__cartItems}
                                        column__total={column__total}

                                        setColumn__userEmail={setColumn__userEmail}
                                        setColumn__orderDate={setColumn__orderDate}
                                        setColumn__cartItems={setColumn__cartItems}
                                        setColumn__total={setColumn__total}
                                        history={props.history}
                                        handleSearchChange={handleSearchChange}
                                    />
                                </div>

                                <div className="st-listing-table abandonedCart-table">
                                    <AbandonedCartTable
                                        allCheckboxSelected={allCheckboxSelected}
                                        handleSelectAllChange={ev => handleSelectAllChange(ev)}
                                        abandonedCart={abandonedCart}
                                        column__userEmail={column__userEmail}
                                        column__orderDate={column__orderDate}
                                        column__cartItems={column__cartItems}
                                        column__total={column__total}

                                        loadingCount={loadingCount}
                                        loading={loading}
                                        handleDelete={(ev, id) => handleDelete(ev, id)}

                                        orderStatusList={orderStatusList}
                                    />

                                </div>
                            </div>

                            <div className="pagination-container d-flex justify-content-end">
                                <Pagination
                                    searchQuery={searchQuery}
                                    routeName={"/my-sales/abandoned-carts"}
                                    paginationLinks={paginationLinks}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </Container>
        </section>
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        commonToken: state.auth.commonToken,
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         functionsData: (prop) => dispatch(functionsData(prop)),
//     }
// }

export default connect(getDataFromStore, null)(AbandonedCart)